import React, { Component } from "react";
import "./ConfirmationEmail.css";
import FetchServerData from "../../../../provider/FetchServerData";
import PtsAlert from "../../ptsAlert/PtsAlert";
import Footer from "../../../website/home/Footer";
import givBeeLogo from "../../../website/home/assets/img/givbeeLogo.png";
import { withRouter } from "../../../../withRouter";
import { ResendVerificationCode_Url } from "../../../../provider/ServiceUrl";
class ConfirmationEmail extends Component {
  constructor(props) {
    super(props);
    let email = props.email;
    if (props.state) {
      email = props.state.email;
    }
    this.state = {
      email: email,
    };
  }
  ResendConfirmationEmail = (e) => {
    e.preventDefault();
    const postObject = {
      registration: {
        email: this.state.email,
      },
    };
    FetchServerData.callPostService(ResendVerificationCode_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
        } else {
        }
      })
      .catch((error) => {});
  };
  ConfirmationEmail() {
    this.props.navigate("/verifyAccount", {
      state: {
        email: this.state.email,
      },
    });
  }
  render() {
    return (
      <>
        <header id="header" className="fixed-top d-flex align-items-center">
          <div className="container d-flex align-items-center justify-content-between">
            <div className="logo">
              {/* <h1>
                  <a href="index.html">Vesperr</a>
                </h1> */}
              <img
                src={givBeeLogo}
                alt=""
                style={{ width: "auto", height: "70px" }}
              />
              {/* Uncomment below if you prefer to use an image logo */}
              {/* <a href="index.html"><img src="assets/img/logo.png" alt="" class="img-fluid"></a>*/}
            </div>
            <nav id="navbar" className="navbar">
              <ul>
                <li className="dropdown ">
                  <a href="/">
                    <span>Solutions</span> <i className="bi bi-chevron-down" />
                  </a>
                  <ul id="dropDownList">
                    <li style={{ borderBottom: "1px solid #D7DBDD" }}>
                      <a href="/nonprofits">
                        For Nonprofits & Small Businesses
                      </a>
                    </li>

                    <li style={{ borderBottom: "1px solid #D7DBDD" }}>
                      <a href="/eventtext">EVENTtext</a>
                    </li>
                    <li>
                      <a href="/restaurant-and-food-truck-texting">
                        For Restaurants & Food Trucks
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a className="nav-link scrollto" href="/signin">
                    Login
                  </a>
                </li>
                <li className="active">
                  <a
                    className="nav-link scrollto"
                    href="/donation/users/regspackagefund"
                  >
                    Sign Up
                  </a>
                </li>
                <li>
                  <a className="nav-link scrollto" href="/blog">
                    Blog
                  </a>
                </li>
                <li>
                  <a className="nav-link scrollto " href="/contactus">
                    Contact
                  </a>
                </li>
                <li>
                  <a className="nav-link scrollto" href="/faqs">
                    Faq
                  </a>
                </li>
              </ul>
              <i className="bi bi-list mobile-nav-toggle" />
            </nav>
            {/* .navbar */}
          </div>
        </header>
        {/* <div className="container cardBox">
          <div className="row d-flex align-items-center justify-content-center">
            <div className="card text-center">
              <div className="card-body">
                <div className="card-title">
                  <div className="confirmationCardHeading">
                    Thank you for signing up.
                    <br></br>
                    You will receive an email shortly.
                  </div>
                </div>
                <p className="card-text">
                  {" "}
                  If you do not receive your confirmation email. Please check
                  your spam or junk mail box of your email client.
                </p>
                <button
                  className="button"
                  onClick={this.ConfirmationEmail.bind(this)}
                >
                  Verification Code
                </button>
                <br></br>
                <div className="resendEmail">
                  <a href="#" onClick={this.ResendConfirmationEmail.bind(this)}>
                    Resend Verification Email
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div
          className="authentication-wrapper authentication-cover"
          style={{ padding: "10em 2em 4em 2em" }}
        >
          <div className="authentication-inner row m-0">
            <div
              className="d-flex col-12 col-lg-6 col-xl-6 align-items-center leftBackground "
              style={{ textAlign: "center" }}
            >
              <div className="mx-auto">
                {/* <div className="logoBackground"> */}
                <img
                  src={givBeeLogo}
                  className="img-fluid logoImage"
                  // id="logoStyle"
                  style={{ width: "50%" }}
                  alt=""
                  data-app-dark-img="illustrations/girl-with-laptop-dark.png"
                  data-app-light-img="illustrations/girl-with-laptop-light.png"
                />
                {/* </div> */}
                <h2 className="logoHeding">
                  <b>GivBee</b>
                </h2>
                {/* <span className="logoText">
                  One Stop Solution for Business Financials along with GST
                  Compliance
                </span> */}
              </div>
            </div>
            <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center authentication-bg  p-4">
              <div className="row">
                <div className="col-md-12" style={{ textAlign: "center" }}>
                  <div className="confirmationCardHeading">
                    Thank you for signing up.
                    <br></br>
                    You will receive an email shortly.
                  </div>

                  <p className="card-text">
                    {" "}
                    If you do not receive your confirmation email. Please check
                    your spam or junk mail box of your email client.
                  </p>
                  <button
                    className="button"
                    onClick={this.ConfirmationEmail.bind(this)}
                  >
                    Verification Code
                  </button>
                  <br></br>
                  <div className="resendEmail">
                    <a
                      href="#"
                      onClick={this.ResendConfirmationEmail.bind(this)}
                    >
                      Resend Verification Email
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
export default withRouter(ConfirmationEmail);
